module.exports = __webpack_public_path__ + "img/arrow-down-left-circle-fill.128faebf.svg";